module.exports = __webpack_public_path__ + "static/media/sarkilar.15b668c0.png";